import {
  Box,
  BoxProps,
  CardProps,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

import { OverviewTableCell } from "../../molecules/overview-table-cell/overview-table-cell";
import { OverviewTableCellHeader } from "../../molecules/overview-table-cell/overview-table-cell-header";

export interface TableTextCellProps {
  /** Cell header */
  header?: string;
  /** Cell body */
  body: string;
  /** Additional MUI styling */
  cardProps?: CardProps;
  /** Additional header styling */
  headerProps?: BoxProps;
  /** Additional body styling */
  bodyProps?: BoxProps;
  /** Additional body styling */
  containerProps?: BoxProps;
  /** Show tooltip on hover */
  tooltipShow?: boolean;
  /** Tooltip content */
  tooltipTitle?: string;
  /** End icon */
  endIcon?: JSX.Element;
  /** Icon to display before the header */
  icon?: JSX.Element;
}

export const TableTextCell: PimoReactComponent<TableTextCellProps, "click"> = ({
  header,
  body,
  cardProps,
  headerProps = {},
  bodyProps = {},
  tooltipShow = false,
  tooltipTitle,
  endIcon,
  icon,
  containerProps,
  fireEvent,
}) => {
  const theme = useTheme();

  const handleClick = () => {
    fireEvent && fireEvent("click");
  };

  return (
    <Box
      sx={{
        display: "flex",

        width: "100%",
        ...containerProps?.sx,
      }}
    >
      {tooltipShow ? (
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          disableInteractive
          followCursor
          title={tooltipTitle || ""}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "white",
                "& .MuiTooltip-arrow": {
                  color: "white",
                },
                color: theme.palette.text.primary,
                p: 2,
                fontWeight: 400,
                fontSize: "1rem",
                backgroundColor: "background.paper",
                padding: 1,
                borderRadius: "6px",
                border: "1px solid",
                borderColor: theme.palette.secondary.dark,
                whiteSpace: "pre-wrap",
                lineHeight: "1.4em",
              },
            },
          }}
        >
          <OverviewTableCell {...cardProps} onClick={handleClick}>
            <OverviewTableCellHeader
              sx={{
                ...headerProps.sx,
              }}
            >
              {icon && (
                <Box sx={{ display: "inline", marginRight: 1 }}>{icon}</Box>
              )}
              {header}
            </OverviewTableCellHeader>
            <Typography
              variant="subtitle2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                ...bodyProps.sx,
              }}
            >
              {body}
            </Typography>
          </OverviewTableCell>
        </Tooltip>
      ) : (
        <OverviewTableCell {...cardProps} onClick={handleClick}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",

              gap: 1,
            }}
          >
            <Box sx={{ flex: "1 1 100%", p: 0 }}>
              <OverviewTableCellHeader
                sx={{
                  ...headerProps.sx,
                }}
              >
                {icon && (
                  <Box sx={{ display: "inline", marginRight: 1 }}>{icon}</Box>
                )}
                {header}
              </OverviewTableCellHeader>

              <Typography
                variant="subtitle2"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  ...bodyProps.sx,
                }}
              >
                {body}
              </Typography>
            </Box>
            {endIcon}
          </Box>
        </OverviewTableCell>
      )}
    </Box>
  );
};

export default TableTextCell;
